import styled, { css } from 'styled-components';
import {Button} from 'reactstrap';

export const Option = styled.option`
  text-transform: uppercase;
  font-size: 16px;
  color: white;
  margin-top: -39px;
  margin-bottom: 35px;
  line-height: unset;

  span {
    color: #ff0033;
  }
`;

export const InputWrapper = styled.div`
  margin: 5px;
  max-width: 100%;
`;

export const StyledInput = styled.input`
  margin: 5px;
  width: 99%;
  padding: 7px;
`;

export const InputLabelWrapper = styled.div`
  margin: 5px;
`;

export const LargeButton = styled.button`
  margin: 5px;
  width: 99%;
  padding: 10px;
`;


// WEBPACK FOOTER //
// ./src/components/Admin/FormModal/FormField.styles.ts